import { useStrictLocalization } from "@faire/web/common/localization";
import { useDisplayedOrderNumber } from "./useDisplayedOrderNumber";
import { useIssueType } from "./useIssueType";
export var useIssuePlaceholder = function useIssuePlaceholder() {
  var _useIssueType = useIssueType(),
    lastIssueTypeLabel = _useIssueType.lastIssueTypeLabel;
  var orderNumber = useDisplayedOrderNumber();
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  if (lastIssueTypeLabel && orderNumber) {
    return strictLocalize({
      id: "7qYNJB",
      defaultMessage: "{lastIssueTypeFullyTranslatedSentence} for order {orderNumber}"
    }, {
      lastIssueTypeFullyTranslatedSentence: lastIssueTypeLabel,
      orderNumber: orderNumber
    });
  } else if (lastIssueTypeLabel && !orderNumber) {
    return strictLocalize({
      id: "XBAG8X",
      defaultMessage: "{lastIssueTypeFullyTranslatedSentence}"
    }, {
      lastIssueTypeFullyTranslatedSentence: lastIssueTypeLabel
    });
  }
  return "";
};